module.exports = __webpack_public_path__ + "assets/2877f56302db382135c60984480d9417.png";